import Vue from "vue";

import ModuleDeviceTelemetry from "@DataWeb/Scripts/Components/Modules/ModuleDeviceTelemetry.vue";

export default {
    install: (Vue, options) => {
        // Explorer modules
        Vue.component("app-moduledevicetelemetry", ModuleDeviceTelemetry);
    }
};